import { useState } from 'react';
import { useVantifyContext } from 'integrations-vantify-context-providers';
import {
  getUsers,
  getServiceProviders,
  UserListResponse,
  ServiceProvider,
  VantifyQuery,
} from 'integrations-vantify-client-services';
import { useVantifyBase } from '../useVantifyBase';
import { VantifyOperation, hookMessages } from '../common';

export function useVantifyUser() {
  const { auth } = useVantifyContext();
  const { loading, error, execute, setError } = useVantifyBase();
  const [users, setUsers] = useState<UserListResponse | null>(null);
  const [serviceProviders, setServiceProviders] =
    useState<ServiceProvider[] | null>(null);

  const fetchUsers = async (fetchQuery?: VantifyQuery) => {
    const queryToUse = fetchQuery ?? {};

    if (!auth) {
      setError(e => ({
        ...e,
        [VantifyOperation.FETCH_USERS]: hookMessages.error_FETCH_USERS,
      }));

      return null;
    }

    const response = await execute(
      VantifyOperation.FETCH_USERS,
      () => getUsers(auth, queryToUse),
      hookMessages.error_FETCH_USERS
    );

    if (response?.data) {
      setUsers(response.data);

      return response.data.users;
    }

    return null;
  };

  const fetchServiceProviders = async (
    userId: number,
    query?: VantifyQuery
  ) => {
    if (!auth) {
      setError(e => ({
        ...e,
        [VantifyOperation.FETCH_SERVICE_PROVIDERS]:
          hookMessages.error_FETCH_SERVICE_PROVIDERS,
      }));

      return null;
    }

    const response = await execute(
      VantifyOperation.FETCH_SERVICE_PROVIDERS,
      () => getServiceProviders(auth, userId, query),
      hookMessages.error_FETCH_SERVICE_PROVIDERS
    );

    if (response?.data) {
      setServiceProviders(response.data.serviceproviders);

      return response.data.serviceproviders;
    }

    return null;
  };

  return {
    users,
    serviceProviders,
    loading,
    error,
    fetchUsers,
    fetchServiceProviders,
  };
}
